import AssetCategory from "../../../model/asset/AssetCategory";

/**
 * Fetch asset categories successful action.
 */
export const ASSET_CATEGORIES_FETCHED = "ASSET_CATEGORIES_FETCHED";
export type ASSET_CATEGORIES_FETCHED = { assetCategories: Array<AssetCategory> }

/**
 * Create asset category successful action.
 */
export const ASSET_CATEGORY_CREATED = "ASSET_CATEGORY_CREATED";
export type ASSET_CATEGORY_CREATED = { assetCategory: AssetCategory }

/**
 * Update asset category successful action.
 */
export const ASSET_CATEGORY_UPDATED = "ASSET_CATEGORY_UPDATED";
export type ASSET_CATEGORY_UPDATED = { assetCategory: AssetCategory }

/**
 *  Update asset category sort order successful action.
 */
export const ASSET_CATEGORY_SORT_ORDER_UPDATED = "ASSET_CATEGORY_SORT_ORDER_UPDATED";
export type ASSET_CATEGORY_SORT_ORDER_UPDATED = { assetCategories: Array<AssetCategory> }